// icons - https://icon-sets.iconify.design/
import { Icon } from "@iconify/react";

// Hero Images (add your images to the /images directory with the same names)
import HeroLight from "./images/hero-light.jpg";
import HeroDark from "./images/hero-dark.jpg";
// If you change the import names above then you need to change the export names below
export { HeroLight as Light };
export { HeroDark as Dark };

/* START HERE
 **************************************************************
  Add your GitHub username (string - "YourUsername") below.
*/
export const githubUsername = "h4wkst3r";

// Navbar Logo image
export const navLogo = undefined;

// Blog link icon - https://icon-sets.iconify.design/
export const Blog = <Icon icon="ph:link-bold" />;

/* About Me
 **************************************************************
  Add a second paragraph for the about me section.
*/
export const moreInfo =
  "Passionate cybersecurity practitioner focused on offensive AI capability development and security research. This site contains all of my public security research, which includes conference presentations, blog posts, whitepapers and open-source tools.";

/* Whitepapers
 ************************************************************** 
  Add or remove whitepapers in the SAME format below, choose icons here - https://icon-sets.iconify.design/
*/
export const whitepaperData = [ 
  {
    id: 1,
    name: "Disrupting the Model: Abusing MLOps Platforms to Compromise ML Models and Enterprise Data Lakes",
    link: "https://www.ibm.com/downloads/documents/us-en/11630e2cbc302316",
    date: "January 2025",
  }, 
  {
    id: 2,
    name: "Hiding in the Clouds: Abusing Azure DevOps Services to Bypass Microsoft Sentinel Analytic Rules",
    link: "https://i.blackhat.com/EU-23/Presentations/Whitepapers/EU-23-Hawkins-Hiding-in-the-Clouds-wp.pdf",
    date: "December 2023",
  },
  {
    id: 3,
    name: "Controlling the Source: Abusing Source Code Management Systems",
    link: "https://www.ibm.com/downloads/cas/OG6KNX1E",
    date: "August 2022",
  },
  {
    id: 4,
    name: "Under The Ocean of the Internet – The Deep Web",
    link: "https://www.sans.org/white-papers/37012/",
    date: "May 2016",
  },
  {
    id: 5,
    name: "Case Study: The Home Depot Data Breach",
    link: "https://www.sans.org/white-papers/36367/",
    date: "October 2015",
  }
];


/* Blog Posts
 ************************************************************** 
  Add or remove blog posts in the SAME format below, choose icons here - https://icon-sets.iconify.design/
*/
export const blogPostData = [
  {
    id: 1,
    name: "From Recon to RCE: Attacking the ML Training Environment with MLOKit v1.3",
    link: "https://www.armadin.com/blog-posts/from-recon-to-rce-attacking-the-ml-training-environment-with-mlokit-v1-3",
    date: "July 2026",
  },
  {
    id: 2,
    name: "Pipelines of Privilege: Attack Paths from DevOps to MLOps Infrastructure",
    link: "https://www.armadin.com/blog-posts/pipelines-of-privilege-attack-paths-from-devops-to-mlops-infrastructure",
    date: "April 2026",
  },
  {
    id: 3,
    name: "Automating the Operator: Integrating LLMs into Offensive Security Workflows",
    link: "https://www.armadin.com/blog-posts/automating-the-operator-integrating-llms-into-offensive-security-workflows",
    date: "March 2026",
  },
  {
    id: 4,
    name: "Thinking with the Machine: How LLMs Change the Way We Build Offensive Capabilities",
    link: "https://www.armadin.com/blog-posts/thinking-with-the-machine-how-llms-change-the-way-we-build-offensive-capabilities",
    date: "March 2026",
  },
  {
    id: 5,
    name: "Becoming the Trainer: Attacking ML Training Infrastructure",
    link: "https://www.ibm.com/think/x-force/becoming-the-trainer-attacking-ml-training-infrastructure",
    date: "June 2025",
  },
  {
    id: 6,
    name: "Disrupting the Model: Abusing MLOps Platforms to Compromise ML Models and Enterprise Data Lakes",
    link: "https://www.ibm.com/think/x-force/abusing-mlops-platforms-to-compromise-ml-models-enterprise-data-lakes",
    date: "January 2025",
  },
  {
    id: 7,
    name: "Getting \"In Tune\" with an Enterprise: Detecting Intune Lateral Movement",
    link: "https://www.ibm.com/think/x-force/detecting-intune-lateral-movement",
    date: "September 2024",
  },
  {
    id: 8,
    name: "Controlling the Source: Abusing Source Code Management Systems",
    link: "https://www.ibm.com/think/x-force/abusing-source-code-management-systems",
    date: "August 2022",
  },
  {
    id: 9,
    name: "Applying the Invisibility Cloak: Obfuscate C# Tools to Evade Signature-Based Detection",
    link: "https://www.ibm.com/think/x-force/invisibility-cloak-obfuscate-c-tools-evade-signature-based-detection",
    date: "May 2021",
  },
  {
    id: 10,
    name: "Abusing DLL Misconfigurations – Using Threat Intelligence to Weaponize R&D",
    link: "https://cloud.google.com/blog/topics/threat-intelligence/abusing-dll-misconfigurations/",
    date: "January 2020",
  },
  {
    id: 11,
    name: "SharPersist: Windows Persistence Toolkit in C#",
    link: "https://cloud.google.com/blog/topics/threat-intelligence/sharpersist-windows-persistence-toolkit/",
    date: "September 2019",
  },
  {
    id: 12,
    name: "Hunting COM Objects",
    link: "https://cloud.google.com/blog/topics/threat-intelligence/hunting-com-objects-part-two/",
    date: "June 2019",
  },
  {
    id: 13,
    name: "BYOJ: Bring Your Own JRunscript",
    link: "https://h4wkst3r.blogspot.com/2018/08/byoj-bring-your-own-jrunscript.html",
    date: "August 2018",
  },
  {
    id: 14,
    name: "Dissecting the .NET Download Cradle",
    link: "https://h4wkst3r.blogspot.com/2018/07/dissecting-net-download-cradle.html",
    date: "July 2018",
  },
  {
    id: 15,
    name: "Code Execution with JDK Scripting Tools & Nashorn Javascript Engine",
    link: "https://h4wkst3r.blogspot.com/2018/05/code-execution-with-jdk-scripting-tools.html",
    date: "May 2018",
  },
  {
    id: 16,
    name: "Persistence with Sticky Notes Registry Value",
    link: "https://h4wkst3r.blogspot.com/2018/05/persistence-with-sticky-notes-registry.html",
    date: "May 2018",
  }
];

/* Presentations
 ************************************************************** 
  Add or remove presentations in the SAME format below, choose icons here - https://icon-sets.iconify.design/
*/
export const presentationData = [
  {
    id: 1,
    conference: "Black Hat USA 2026 Arsenal",
    name: "MLOKit: MLOps Attack Toolkit",
    link: "https://blackhat.com/us-26/arsenal/schedule/index.html#mlokit-mlops-attack-toolkit-51764",
  },
  {
    id: 2,
    conference: "SO-CON 2026",
    name: "Pipelines of Privilege: Attack Paths from DevOps to MLOps Infrastructure",
    link: "https://youtu.be/ceeGAb099l0?si=DrdPZnaQa0zPnMVb",
  },
  {
    id: 3,
    conference: "TROOPERS 2025",
    name: "Becoming the Trainer: Attacking ML Training Infrastructure",
    link: "https://www.youtube.com/watch?v=_YnvZ4RMZZQ",
  },
  {
    id: 4,
    conference: "ShmooCon 2025",
    name: "Disrupting the Model: Abusing MLOps Platforms to Compromise ML Models and Enterprise Data Lakes",
    link: "https://youtu.be/Cqz1ovrhnsU?t=568",
  },
  {
    id: 5,
    conference: "BlueHat 2024",
    name: "Getting \"In Tune\" with an Enterprise: Detecting Intune Lateral Movement",
    link: "https://www.youtube.com/watch?v=JKgMJMHO34Q",
  },
  {
    id: 6,
    conference: "Black Hat USA 2024 Arsenal",
    name: "ADOKit: Azure DevOps Services Attack Toolkit",
    link: "https://www.blackhat.com/us-24/arsenal/schedule/index.html#adokit-azure-devops-services-attack-toolkit-38148",
  },
  {
    id: 7,
    conference: "Black Hat Europe 2023 Briefing",
    name: "Hiding in the Clouds: Abusing Azure DevOps Services to Bypass Microsoft Sentinel Analytic Rules",
    link: "https://youtu.be/IYyfRu8Y0f4",
  },
  {
    id: 8,
    conference: "Black Hat USA 2022 Briefing",
    name: "Controlling the Source: Abusing Source Code Management Systems",
    link: "https://www.youtube.com/watch?v=P44opLFcgpA",
  },
  {
    id: 9,
    conference: "Black Hat USA 2022 Arsenal",
    name: "SCMKit: Source Code Management Attack Toolkit",    
    link: "https://www.blackhat.com/us-22/arsenal/schedule/index.html#scmkit-source-code-management-attack-toolkit-26592",
  },
  {
    id: 10,
    conference: "Wild West Hackin Fest 2022",
    name: "Applying the Invisibility Cloak: Obfuscate C# Tools to Evade Signature-Based Detection",    
    link: "https://www.youtube.com/watch?v=JVT4yapkmVI",
  },
  {
    id: 11,
    conference: "DerbyCon 2019",
    name: "SharPersist: Windows Persistence Toolkit in C#",    
    link: "https://www.youtube.com/watch?v=K7o9RSVyazo",
  },
  {
    id: 12,
    conference: "DerbyCon 2018",
    name: "Code Execution with JDK Scripting Tools & Nashorn Javascript Engine",    
    link: "https://www.youtube.com/watch?v=j7HoSU5chV4",
  },
  {
    id: 13,
    conference: "BSides Cleveland 2015",
    name: "Call of Duty: Crypto Ransomware",    
    link: "https://www.youtube.com/watch?v=hxL-CIq64Sw",
  }
];

/* Projects
 ************************************************************** 
  Add or remove projects in the SAME format below, choose icons here - https://icon-sets.iconify.design/
*/
export const projectsData = [
  {
    id: 1,
    name: "Dop2Mop",
    description: "DevOps to MLOps OpenGraph Collector",
    link: "https://github.com/h4wkst3r/Dop2Mop",
  },
  {
    id: 2,
    name: "bloodhound-mcp-server",
    description: "BloodHound MCP Server",
    link: "https://github.com/h4wkst3r/bloodhound-mcp-server",
  },
  {
    id: 3,
    name: "MLOKit",
    description: "MLOps Attack Toolkit",
    link: "https://github.com/h4wkst3r/MLOKit",
  },
  {
    id: 4,
    name: "ADOKit",
    description: "Azure DevOps Services Attack Toolkit",
    link: "https://github.com/h4wkst3r/ADOKit",
  },
  {
    id: 5,
    name: "SCMKit",
    description: "Source Code Management Attack Toolkit",
    link: "https://github.com/h4wkst3r/SCMKit",
  },
  {
    id: 6,
    name: "InvisibilityCloak",    
    description: "Proof-of-concept obfuscation toolkit for C# post-exploitation tools",
    link: "https://github.com/h4wkst3r/InvisibilityCloak",
  },
  {
    id: 7,
    name: "SharPersist",    
    description: "Windows Persistence Toolkit in C#",
    link: "https://github.com/h4wkst3r/SharPersist",
  }
];


